import { STATUSES } from '@/constants/common/message.constants'

import { type TourImportJobExEntity } from '../..'

/**
 * 運行実績取込ステータス
 */
export type TourImportJobStatusType = TourImportJobExEntity['status']

export const TOUR_IMPORT_JOB_STATUS_TYPE = {
  /** 取込待ち */
  PENDING: 'PENDING',
  /** 取込中 */
  IMPORTING: 'IMPORTING',
  /** 完了 */
  COMPLETED: 'COMPLETED',
  /** エラー */
  ERROR: 'ERROR',
  /** 取消済 */
  ROLLED_BACK: 'ROLLED_BACK'
} as const satisfies Record<TourImportJobStatusType, TourImportJobStatusType>

export const TOUR_IMPORT_JOB_STATUS_TYPE_LABEL = {
  [TOUR_IMPORT_JOB_STATUS_TYPE.PENDING]: STATUSES.PENDING,
  [TOUR_IMPORT_JOB_STATUS_TYPE.IMPORTING]: STATUSES.IMPORTING,
  [TOUR_IMPORT_JOB_STATUS_TYPE.COMPLETED]: STATUSES.COMPLETED,
  [TOUR_IMPORT_JOB_STATUS_TYPE.ERROR]: STATUSES.FAILED,
  [TOUR_IMPORT_JOB_STATUS_TYPE.ROLLED_BACK]: STATUSES.ROLLED_BACK
} as const satisfies Record<TourImportJobStatusType, string>
